import {apiUrl} from "../urls";
import {useEffect} from "react";
import usePost from "../axios/usePost";
import {updateCache} from "../helpers/cacheUtils";
import {clone} from "../../utils/misc/helpers";
import {Cruise} from "../../model/Cruise";


const usePostCruise = (cruises: Cruise[], setCruises: Function) => {
  const {
    data,
    setData,
    loading: postCruiseLoading,
    postData: postCruise,
  } = usePost(apiUrl.cruises);

  useEffect(() => {
    if (data) {
      const postResponse = data as Cruise;
      const cacheClone = clone(cruises);
      updateCache([postResponse], cacheClone);
      setCruises(cacheClone);
      setData(null);
    }
  }, [data, cruises, setCruises, setData])

  return {postCruiseLoading, postCruise}
}

export default usePostCruise;